module.exports = __webpack_public_path__ + "static/headerRightBg-aee9acdb02e740c91bc8f8aef94e02c4.png";